var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIfixitHeaderLogoUa = function SvgIfixitHeaderLogoUa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 52,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 466.99 184.73",
    style: {
      display: "block"
    }
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ifixit-header-logo-ua_svg__clip-path",
    transform: "translate(35.91 27.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.32 0a65.32 65.32 0 1 0 65.32 65.31A65.31 65.31 0 0 0 65.32 0Zm18.2 68.07 12.92 17.05a4.81 4.81 0 0 1 .13 5.23l-.65 1a21.67 21.67 0 0 1-4.44 4.53l-1.56 1.09a4.67 4.67 0 0 1-5.19-.09l-17-12.93a4.52 4.52 0 0 0-5.14 0l-17 12.93a4.74 4.74 0 0 1-5.21.12l-1.13-.78a21.43 21.43 0 0 1-4.5-4.47l-1-1.39a4.74 4.74 0 0 1 .1-5.21l12.86-17.1a4.5 4.5 0 0 0 0-5.13L33.77 45.86a4.71 4.71 0 0 1-.09-5.2l1.1-1.56a21.38 21.38 0 0 1 4.52-4.44l1-.65a4.78 4.78 0 0 1 5.22.13l17 12.93a4.52 4.52 0 0 0 5.14 0l17-12.93a5.2 5.2 0 0 1 5.34-.3l1.78 1a14.07 14.07 0 0 1 4.34 4.45l.63 1.14a5.38 5.38 0 0 1-.38 5.38L83.52 62.92a4.53 4.53 0 0 0 0 5.15Z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".ifixit-header-logo-ua_svg__cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "ifixit-header-logo-ua_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ifixit-header-logo-ua_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ifixit-header-logo-ua_svg__cls-2",
    d: "M161.82 41.14a6.89 6.89 0 1 1 13.78 0v49.91a6.89 6.89 0 1 1-13.78 0ZM191.25 41.68a6.83 6.83 0 0 1 6.89-6.89h35.06a6.26 6.26 0 1 1 0 12.52H205v13.33h24.15a6.26 6.26 0 0 1 0 12.52H205v17.89a6.89 6.89 0 0 1-13.78 0ZM250.56 41.14a6.89 6.89 0 1 1 13.77 0v49.91a6.89 6.89 0 1 1-13.77 0ZM353.7 41.14a6.89 6.89 0 1 1 13.77 0v49.91a6.89 6.89 0 1 1-13.77 0ZM397.71 47.49h-13.24a6.35 6.35 0 0 1 0-12.7h40.25a6.35 6.35 0 0 1 0 12.7h-13.24v43.56a6.89 6.89 0 1 1-13.77 0ZM318.94 66.47l19.62-19.62a7 7 0 1 0-9.93-9.93L309 56.54l-19.6-19.62a7 7 0 0 0-9.93 9.93l19.62 19.62-19.62 19.61A7 7 0 1 0 289.4 96L309 76.39 328.63 96a7 7 0 1 0 9.93-9.93Z",
    transform: "translate(35.91 27.05)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#ifixit-header-logo-ua_svg__clip-path)"
    },
    id: "ifixit-header-logo-ua_svg__ifixit-logo-black-blue-horiz-RGB"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd400"
    },
    d: "M35.91 92.36h149.78v92.37H0V92.66l35.91-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0071ce"
    },
    d: "M35.91 0h149.78v92.37H0V.3L35.91 0z"
  })))));
};

export default SvgIfixitHeaderLogoUa;